import { SCREEN_GAP_OPTIONS } from './options.js';
export const SETTINGS_MENU_ITEMS = [
    { value: 'themeMode', label: '화면 모드' },
    { value: 'blockedUsers', label: '차단 사용자 관리' },
    { value: 'notifications', label: '알림 설정' },
    { value: 'appPermissions', label: '앱 권한' },
    { value: 'appVersion', label: '앱 버전' },
];
export const SETTINGS_SCREEN_FIELDS = [
    {
        key: 'settings.menu.order',
        group: '메뉴',
        label: '메뉴 순서',
        help: '내 정보 > 설정 화면의 메뉴 줄 순서. 개발자 메뉴(개발자 모드에서만 보임)는 항상 앱 버전 바로 위에 붙는다',
        type: 'order',
        defaultValue: SETTINGS_MENU_ITEMS.map((item) => item.value),
        items: SETTINGS_MENU_ITEMS,
    },
    {
        key: 'settings.menu.dividerVisible',
        group: '메뉴',
        label: '메뉴 사이 구분선',
        help: '끄면 설정 화면 메뉴 줄 사이의 가는 선을 그리지 않는다',
        type: 'boolean',
        defaultValue: true,
    },
    {
        key: 'settings.accountButtons.gap',
        group: '로그아웃·회원 탈퇴',
        label: '로그아웃·회원 탈퇴 버튼 사이 간격',
        help: '설정 화면 아래 로그아웃 버튼과 회원 탈퇴 버튼 사이의 간격',
        type: 'enum',
        defaultValue: 'default',
        options: SCREEN_GAP_OPTIONS,
    },
];
//# sourceMappingURL=settings.js.map